// language=GraphQL
export const ALL_TRAVEL_EXTENSIONS_QUERY = `query Query($withHighlights: Boolean = false, $withImage: Boolean = false) {
  travelExtensions: travelExtensions {
    id
    duration
    name
    description
    highlights @include(if: $withHighlights) {
      id
      text
    }
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const SINGLE_TRAVEL_EXTENSION_QUERY = `query Query($id: ID!, $withHighlights: Boolean = false, $withImage: Boolean = false) {
  travelExtension: travelExtension(id: $id) {
    id
    duration
    name
    description
    highlights @include(if: $withHighlights) {
      id
      text
    }
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const CREATE_TRAVEL_EXTENSION_MUTATION = `
  mutation Mutation($input: CreateTravelExtensionInput, $withHighlights: Boolean = false, $withImage: Boolean = false) {
    travelExtension: createTravelExtension(input: $input) {
      id
      duration
      name
      description
      highlights @include(if: $withHighlights) {
        id
        text
      }
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_EXTENSION_MUTATION = `
  mutation Mutation($input: UpdateTravelExtensionInput, $withHighlights: Boolean = false, $withImage: Boolean = false) {
    travelExtension: updateTravelExtension(input: $input) {
      id
      duration
      name
      description
      highlights @include(if: $withHighlights) {
        id
        text
      }
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_EXTENSION_MUTATION = `
  mutation Mutation($input: DeleteTravelExtensionInput) {
    deleteTravelExtension(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TRAVEL_EXTENSION_MUTATION = `
  mutation Mutation($input: DeleteTravelExtensionInput) {
    forceDeleteTravelExtension(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_EXTENSION_HIGHLIGHTS_MUTATION = `
  mutation Mutation($input: addTravelExtensionHighlightsInput) {
    addTravelExtensionHighlights(input: $input) {
      id
      highlightIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_EXTENSION_HIGHLIGHTS_MUTATION = `
  mutation Mutation($input: removeTravelExtensionHighlightsInput) {
    removeTravelExtensionHighlights(input: $input) {
      id
      highlightIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_EXTENSION_HIGHLIGHTS_MUTATION = `
  mutation Mutation($input: createTravelExtensionHighlightsInput) {
    createTravelExtensionHighlights(input: $input) {
      id
      highlightIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_EXTENSION_HIGHLIGHTS_MUTATION = `
  mutation Mutation($input: deleteTravelExtensionHighlightsInput) {
    deleteTravelExtensionHighlights(input: $input) {
      id
      highlightIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_EXTENSION_HIGHLIGHTS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelExtensionHighlightsOrderInput) {
    updateTravelExtensionHighlightsOrder(input: $input) {
      id
      highlightIds
    }
  }`

// language=GraphQL
export const TRAVEL_EXTENSIONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioTravelExtensions: Boolean = false, $withTravels: Boolean = false) {
  groupedDependents: travelExtensionDependents(id: $id) {
    ratioTravelExtensions @include(if: $withRatioTravelExtensions) {
      id
      label
      info
    }
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency    }
  }
}`
